import { render, staticRenderFns } from "./AsideBarNotes.vue?vue&type=template&id=266515d7"
import script from "./AsideBarNotes.vue?vue&type=script&lang=js"
export * from "./AsideBarNotes.vue?vue&type=script&lang=js"
import style0 from "./AsideBarNotes.vue?vue&type=style&index=0&id=266515d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports